import {
  SubTabPlan2,
  SubTabPlan1,
  SubTabPlan3,
  SubTabPlan4,
} from './components';

export const tabsBusinessPlan = () =>
  [
    {
      label: `3.1 Περιγραφή της Επένδυσης`,
      id: '3_1',
      Component: SubTabPlan1,
    },
    {
      label: `3.2 Χρηματοδοτικά Προγράμματα`,
      id: '3_2',
      Component: SubTabPlan2,
    },
    {
      label: `3.3 Δαπάνες Επένδυσης`,
      id: '3_3',
      Component: SubTabPlan3,
    },
    {
      label: `3.4 Έσοδα Επένδυσης`,
      id: '3_4',
      Component: SubTabPlan4,
    },
  ].filter(item => !item?.hidden);
